import React from "react";
import Masthead from "./Masthead"
import awsCloudImage from "../Images/portfolio/aws_cloud.svg";
import awsMigrationImage from "../Images/portfolio/aws_migration.svg";
import awsDevopsImage from "../Images/portfolio/aws_devops.svg";
import aiImage from "../Images/portfolio/ai.svg";
import AwsCloudModal from "./modals/AwsCloudModal";
import AWSMigModal from "./modals/AWSMigModal";
import AwsDevOpsModal from "./modals/AwsDevOpsModal";
import AiModal from "./modals/AiModal";
import Certificates from "./Certificates";

const HomePage = () => {
  return (
    <div>
       <Masthead />
       <section class="page-section portfolio" id="portfolio">
            <div class="container">
                {/*<!-- Portfolio Section Heading-->*/}
                <h2 class="page-section-heading text-center text-uppercase text-secondary mb-0">Experiences</h2>
                {/*<!-- Icon Divider-->*/}
                <div class="divider-custom">
                    <div class="divider-custom-line"></div>
                    <div class="divider-custom-icon"><i class="fas fa-star"></i></div>
                    <div class="divider-custom-line"></div>
                </div>
                {/*<!-- Portfolio Grid Items-->*/}
                <div class="row justify-content-center">
                    {/*<!-- Portfolio Item 1-->*/}
                    <div class="col-md-6 col-lg-4 mb-5">
                        <div class="portfolio-item mx-auto" data-bs-toggle="modal" data-bs-target="#portfolioModal1">
                            <div class="portfolio-item-caption d-flex align-items-center justify-content-center h-100 w-100">
                                <div class="portfolio-item-caption-content text-center text-white"><i class="fas fa-plus fa-3x"></i></div>
                            </div>
                            <img class="img-fluid" src={awsCloudImage} alt="..." />
                            <AwsCloudModal />
                        </div>
                    </div>
                    {/*<!-- Portfolio Item 2-->*/}
                    <div class="col-md-6 col-lg-4 mb-5">
                        <div class="portfolio-item mx-auto" data-bs-toggle="modal" data-bs-target="#portfolioModal2">
                            <div class="portfolio-item-caption d-flex align-items-center justify-content-center h-100 w-100">
                                <div class="portfolio-item-caption-content text-center text-white"><i class="fas fa-plus fa-3x"></i></div>
                            </div>
                            <img class="img-fluid" src={awsMigrationImage} alt="..." />
                            <AWSMigModal />
                        </div>
                    </div>
                    {/*<!-- Portfolio Item 3-->*/}
                    <div class="col-md-6 col-lg-4 mb-5">
                        <div class="portfolio-item mx-auto" data-bs-toggle="modal" data-bs-target="#portfolioModal3">
                            <div class="portfolio-item-caption d-flex align-items-center justify-content-center h-100 w-100">
                                <div class="portfolio-item-caption-content text-center text-white"><i class="fas fa-plus fa-3x"></i></div>
                            </div>
                            <img class="img-fluid" src={awsDevopsImage} alt="..." />
                            <AwsDevOpsModal />
                        </div>
                    </div>
                    {/*<!-- Portfolio Item 4-->*/}
                    <div class="col-md-6 col-lg-4 mb-5 mb-lg-0">
                        <div class="portfolio-item mx-auto" data-bs-toggle="modal" data-bs-target="#portfolioModal4">
                            <div class="portfolio-item-caption d-flex align-items-center justify-content-center h-100 w-100">
                                <div class="portfolio-item-caption-content text-center text-white"><i class="fas fa-plus fa-3x"></i></div>
                            </div>
                            <img class="img-fluid" src={aiImage} alt="..." />
                            <AiModal />
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <Certificates />
    </div>
  )
};

export default HomePage;